/**
 * Bio component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

// import { rhythm } from "../utils/typography"

function Bio() {
    return (
        <StaticQuery
            query={bioQuery}
            render={(data) => {
                const { author, social } = data.site.siteMetadata
                return (
                    <div
                        style={{
                            display: `flex`,
                            alignItems: "center",
                        }}
                    >
                        <Image
                            style={{
                                marginRight: "0.5rem",
                                marginBottom: 0,
                                minWidth: 50,
                                borderRadius: `100%`,
                            }}
                            imgStyle={{
                                borderRadius: `50%`,
                            }}
                            fixed={data.avatar.childImageSharp.fixed}
                            alt={author}
                        />
                        {/*<GatsbyImage*/}
                        {/*  style={{*/}
                        {/*    marginRight: "0.5rem",*/}
                        {/*    marginBottom: 0,*/}
                        {/*    minWidth: 50,*/}
                        {/*    borderRadius: `100%`,*/}
                        {/*  }}*/}
                        {/*  imgStyle={{*/}
                        {/*    borderRadius: `50%`,*/}
                        {/*  }}*/}
                        {/*  image={data.avatar.childImageSharp.gatsbyImageData}*/}
                        {/*  alt={author}*/}
                        {/*/>*/}
                        <p>
                            Written by <strong>{author}</strong>
                            {` `}
                            <a href={`http://github.com/${social.github}`}>
                                You should follow him on Github
                            </a>
                        </p>
                    </div>
                )
            }}
        />
    )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
        #        gatsbyImageData(layout: FIXED, width: 50, height: 50, formats: [JPG])
      }
    }
    site {
      siteMetadata {
        author
        social {
          github
        }
      }
    }
  }
`

export default Bio
